import React from 'react';
import PropTypes from 'prop-types';

import styles from './breadcrumbs.scss';

function Breadcrumbs({ breadcrumbs }) {
    return (<nav className={styles['breadcrumb-container']}>
        {breadcrumbs.map(options => (
            <a className={styles['breadcrumb-link']} key={options['data-name']} {...options}>
                {options['data-name']}
            </a>
        ))}
    </nav>)
}

Breadcrumbs.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
        'data-name': PropTypes.string.isRequired,
        'data-breadcrumb': PropTypes.string.isRequired,
        'data-action': PropTypes.string,
        'data-value': PropTypes.string,
        onClick: PropTypes.func.isRequired,
    }),).isRequired,
};

Breadcrumbs.defaultProps = {
    breadcrumbs: [],
};

export default Breadcrumbs;
